import React, { Fragment } from 'react'
import { Visible } from '@leroy-merlin-br/backyard-react-ui'

import { Image } from './styled'

const BannerWebAwards = ({ catalogs }) => (
  <Fragment>
    {catalogs.map(item => (
      <a
        key={item.slug}
        href={item.url}
        target="_blank"
        title="Troque seus pontos por: produtos, viagens e experiências"
      >
        <Visible kilo mega giga tera>
          <Image src={item.banners?.desktop} alt="web-awards-banner" />
        </Visible>

        <Visible untilKilo>
          <Image src={item.banners?.mobile} alt="web-awards-banner-mobile" />
        </Visible>
      </a>
    ))}
  </Fragment>
)

export default BannerWebAwards
